import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';
import { hydrateRoot } from 'react-dom/client';

import { IReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';

interface IDependencies {
  store: IReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;
  const {
    servicePage: { deviceType },
  } = store.getState();

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <UiKitRoot deviceType={deviceType} useStaticDeviceType>
      <UiKitToastsContextProvider>
        <Application config={config} logger={getLogger()} reduxStore={store} customContext={customContext} />
      </UiKitToastsContextProvider>
    </UiKitRoot>,
  );
}
